import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"
import { useNavigate } from "react-router-dom";
import { Trash } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TrialAccount {
    storeUrl: string
    expiresAt: string // ISO date string
    hooksCount: number
    usage: number
}

// Function to format date in the format 'YYYY-MM-DD HH:MM'
const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}`;
}


interface TrialAccountsTableProps {
    accounts: TrialAccount[];
    showActions?: boolean;
    onDeleteAccount?: (storeUrl: string) => void;
}

export function TrialAccountsPane({ accounts, showActions = false, onDeleteAccount }: TrialAccountsTableProps) {
    const navigate = useNavigate()

    return (
        <Table>
            <TableHeader className="bg-gray-100">
                <TableRow>
                    <TableHead className="py-2 w-[40%]">Store URL</TableHead>
                    <TableHead className="py-2">Trial expires at</TableHead>
                    <TableHead className="py-2 text-right"># of hooks</TableHead>
                    <TableHead className="py-2 text-right">Trial usage</TableHead>
                    {showActions && (
                        <TableHead className="py-2 text-right">Actions</TableHead>
                    )}
                </TableRow>
            </TableHeader>
            <TableBody>
                {accounts.map((account) => (
                    <TableRow key={account.storeUrl}>
                        <TableCell className="py-2">
                            <button
                                className="text-blue-600 hover:underline"
                                onClick={() => navigate(`/account/${account.storeUrl}`) }
                            >
                                {account.storeUrl}
                            </button>
                        </TableCell>
                        <TableCell className="py-2">{formatDate(account.expiresAt)}</TableCell>
                        <TableCell className="py-2 text-right">{account.hooksCount}</TableCell>
                        <TableCell className="py-2 text-right">{account.usage}</TableCell>
                        {showActions && (
                            <TableCell className="py-2 text-right">
                                <Button
                                    variant="ghost"
                                    size="icon"
                                    onClick={() => onDeleteAccount && onDeleteAccount(account.storeUrl)}
                                    title="Delete account"
                                >
                                    <Trash className="h-4 w-4" />
                                </Button>
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    )
}
